import { CUSTOMER_SIDE_ROUTES } from '@tracking/constants'

export const ALLOWED_ROUTES = CUSTOMER_SIDE_ROUTES
